(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uv-breadcrumbs')) {
    class UVBreadcrumbs extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'uv:breadcrumbs:last-collection';
        this.additionalItem = this.querySelector('[data-additional-item]');
        this.additionalLink = this.querySelector('[data-additional-link]');
        this.backButton = this.querySelector('[data-back-button]');
        this.scrollContainer = this.querySelector('[data-breadcrumb-scroll]');

        this.setupScrollableNavigation();
        this.setupCollectionLoading();

        if (this.dataset.pageType === 'collection') {
          this.rememberCurrentCollection();
        }

        if (this.dataset.pageType === 'product' && this.dataset.additionalMode === 'context') {
          this.resolveBrowsingCollection();
        }

        this.setupBackButton();
      }

      setupScrollableNavigation() {
        if (!this.scrollContainer) return;

        const scroller = this.scrollContainer;
        const updateOverflowState = () => {
          scroller.classList.toggle('is-scrollable', scroller.scrollWidth > scroller.clientWidth + 1);
        };

        updateOverflowState();

        if ('ResizeObserver' in window) {
          this.scrollResizeObserver = new ResizeObserver(updateOverflowState);
          this.scrollResizeObserver.observe(scroller);
          const list = scroller.firstElementChild;
          if (list) this.scrollResizeObserver.observe(list);
        } else {
          window.addEventListener('resize', updateOverflowState, { passive: true });
          this.scrollResizeFallback = updateOverflowState;
        }

        /*
         * Deliberately no mouse/pen drag-to-scroll logic.
         * Mobile keeps native finger swiping and desktop keeps native
         * trackpad / horizontal-wheel scrolling. Links remain plain links.
         */

        /* Keyboard focus is kept visible when the rail overflows. */
        scroller.addEventListener('focusin', (event) => {
          const link = event.target.closest('a');
          if (!link || !scroller.contains(link)) return;
          link.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      }

      setupCollectionLoading() {
        const links = this.querySelectorAll('[data-collection-link]');

        links.forEach((link) => {
          link.addEventListener('click', (event) => {
            if (event.defaultPrevented) return;
            if (event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (link.target && link.target !== '_self') return;

            let destination;
            try {
              destination = new URL(link.href, window.location.href);
            } catch (error) {
              return;
            }

            if (destination.href === window.location.href) return;

            link.classList.add('is-loading');
            link.setAttribute('aria-busy', 'true');
          });
        });

        /* If a page is restored from the browser back/forward cache, clear stale loading UI. */
        this.pageShowHandler = () => {
          this.querySelectorAll('[data-collection-link].is-loading').forEach((link) => {
            link.classList.remove('is-loading');
            link.removeAttribute('aria-busy');
          });

          if (this.backButton) {
            this.backButton.classList.remove('is-loading');
            this.backButton.removeAttribute('aria-busy');
            this.backButton.removeAttribute('aria-disabled');
          }
        };
        window.addEventListener('pageshow', this.pageShowHandler);
      }

      disconnectedCallback() {
        this.scrollResizeObserver?.disconnect();
        if (this.scrollResizeFallback) {
          window.removeEventListener('resize', this.scrollResizeFallback);
        }
        if (this.pageShowHandler) {
          window.removeEventListener('pageshow', this.pageShowHandler);
        }
      }

      getStoredCollection() {
        try {
          const value = sessionStorage.getItem(this.storageKey);
          return value ? JSON.parse(value) : null;
        } catch (error) {
          return null;
        }
      }

      storeCollection(collection) {
        if (!collection?.handle || !collection?.url || !collection?.title) return;

        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify(collection));
        } catch (error) {
          // Storage can be unavailable in strict privacy modes; breadcrumbs still work without it.
        }
      }

      rememberCurrentCollection() {
        const handle = this.dataset.currentCollectionHandle;
        const title = this.dataset.currentCollectionTitle;
        const url = this.dataset.currentCollectionUrl;
        const mainHandle = this.dataset.mainHandle;

        if (!handle || handle === mainHandle) return;
        this.storeCollection({ handle, title, url });
      }

      getProductCollections() {
        const data = this.querySelector('[data-product-collections]');
        if (!data) return [];

        try {
          const parsed = JSON.parse(data.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }

      resolveBrowsingCollection() {
        const mainHandle = this.dataset.mainHandle;
        const collections = this.getProductCollections().filter((item) => item?.handle && item.handle !== mainHandle);
        if (!collections.length) return;

        const byHandle = new Map(collections.map((item) => [item.handle, item]));
        let match = null;

        if (document.referrer) {
          try {
            const referrer = new URL(document.referrer);
            if (referrer.origin === window.location.origin) {
              const result = referrer.pathname.match(/\/collections\/([^/?#]+)/i);
              const handle = result?.[1] ? decodeURIComponent(result[1]) : '';
              if (handle && byHandle.has(handle)) match = byHandle.get(handle);
            }
          } catch (error) {
            // Ignore invalid referrers.
          }
        }

        if (!match) {
          const stored = this.getStoredCollection();
          if (stored?.handle && byHandle.has(stored.handle)) {
            match = byHandle.get(stored.handle);
          }
        }

        if (!match) return;

        this.setAdditionalCollection(match);
        this.storeCollection(match);
      }

      setAdditionalCollection(collection) {
        if (!this.additionalItem || !this.additionalLink || !collection) return;

        this.additionalLink.href = collection.url;
        const label = this.additionalLink.querySelector('.uv-breadcrumbs__link-label');
        if (label) {
          label.textContent = collection.title;
        } else {
          this.additionalLink.textContent = collection.title;
        }
        this.additionalLink.dataset.handle = collection.handle;
        this.additionalItem.hidden = false;
        this.dataset.resolvedAdditionalUrl = collection.url;
      }

      setupBackButton() {
        if (!this.backButton) return;

        this.backButton.addEventListener('click', (event) => {
          event.preventDefault();

          if (this.backButton.classList.contains('is-loading')) return;

          this.backButton.classList.add('is-loading');
          this.backButton.setAttribute('aria-busy', 'true');
          this.backButton.setAttribute('aria-disabled', 'true');

          /*
           * Build a deterministic hierarchy fallback first.
           * Product -> visible/resolved middle collection -> Main collection -> configured fallback -> Home.
           * This also works inside Shopify Theme Editor, where document.referrer is often the Admin/editor URL.
           */
          const visibleAdditionalUrl =
            this.additionalItem && !this.additionalItem.hidden && this.additionalLink
              ? this.additionalLink.getAttribute('href') || ''
              : '';

          const nearestCollection =
            this.dataset.resolvedAdditionalUrl ||
            visibleAdditionalUrl ||
            this.dataset.mainUrl ||
            '';

          const fallback = nearestCollection || this.dataset.backFallback || '/';

          const goToFallback = () => {
            let fallbackUrl;
            try {
              fallbackUrl = new URL(fallback, window.location.origin);
            } catch (error) {
              fallbackUrl = new URL('/', window.location.origin);
            }

            /* Never intentionally reload the exact same page as a fallback. */
            if (fallbackUrl.href === window.location.href) {
              fallbackUrl = new URL('/', window.location.origin);
            }

            window.location.assign(fallbackUrl.href);
          };

          let referrer = null;
          if (document.referrer) {
            try {
              referrer = new URL(document.referrer);
            } catch (error) {
              referrer = null;
            }
          }

          const hasUsableSameStoreHistory =
            referrer &&
            referrer.origin === window.location.origin &&
            referrer.href !== window.location.href &&
            window.history.length > 1;

          if (!hasUsableSameStoreHistory) {
            requestAnimationFrame(() => {
              requestAnimationFrame(goToFallback);
            });
            return;
          }

          /*
           * Prefer true browser Back for normal same-store navigation.
           * Some browsers/embedded previews can ignore history.back(), so keep a short
           * failsafe. If pagehide/beforeunload fires, navigation succeeded and the
           * fallback timer is cancelled.
           */
          let navigationStarted = false;
          let fallbackTimer = null;

          const markNavigationStarted = () => {
            navigationStarted = true;
            if (fallbackTimer) window.clearTimeout(fallbackTimer);
          };

          window.addEventListener('pagehide', markNavigationStarted, { once: true });
          window.addEventListener('beforeunload', markNavigationStarted, { once: true });

          window.history.back();

          fallbackTimer = window.setTimeout(() => {
            if (!navigationStarted && document.visibilityState === 'visible') {
              goToFallback();
            }
          }, 700);
        });
      }
    }

    customElements.define('uv-breadcrumbs', UVBreadcrumbs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-shipping-goal-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('uv-shipping-goal')) return;

    class UVShippingGoal extends HTMLElement {
      connectedCallback() {
        this.thresholdMode = this.dataset.thresholdMode === 'amount' ? 'amount' : 'items';
        this.thresholdItems = Math.max(1, Number.parseInt(this.dataset.thresholdItems, 10) || 3);
        this.thresholdAmount = Math.max(0.01, Number.parseFloat(this.dataset.thresholdAmount) || 85);
        this.itemLabelSingular = this.dataset.itemLabelSingular || 'item';
        this.itemLabelPlural = this.dataset.itemLabelPlural || 'items';
        this.currencyCode = this.dataset.currencyCode || 'USD';
        this.hideProgressOnSuccess = this.dataset.hideProgressOnSuccess === 'true';
        this.autoHideOnSuccess = this.dataset.autoHideOnSuccess === 'true';
        this.successHideDelay = Math.max(0, Number(this.dataset.successHideDelay) || 4000);
        this.enableFloat = this.dataset.enableFloat === 'true';
        this.currentItemCount = Math.max(0, Number(this.dataset.initialItemCount) || 0);
        this.currentCartTotal = Math.max(0, Number(this.dataset.initialCartTotal) || 0);

        this.main = this.querySelector('.uv-shipping-goal__main');
        this.trackShell = this.querySelector('[data-uv-track-shell]');
        this.configuredFontSize =
          Number.parseFloat(getComputedStyle(this).getPropertyValue('--uv-sp-font-size')) || 13;
        this.minimumFitFontSize = 9;

        this.stateNodes = {
          empty: this.querySelector('[data-uv-state="empty"]'),
          progress: this.querySelector('[data-uv-state="progress"]'),
          success: this.querySelector('[data-uv-state="success"]'),
        };
        this.remainingNodes = this.querySelectorAll('[data-uv-remaining], [data-uv-float-remaining]');
        this.progressWrap = this.querySelector('[data-uv-progress-wrap]');
        this.floatProgressWrap = this.querySelector('[data-uv-float-progress-wrap]');
        this.floatTrackShell = this.querySelector('[data-uv-float-track-shell]');
        this.progressBar = this.querySelector('[data-uv-progressbar]');
        this.fills = this.querySelectorAll('[data-uv-fill]');
        this.movingIcon = this.querySelector('[data-uv-moving-icon]');
        this.bgLabel = this.querySelector('[data-uv-bg-label]');
        this.floatBgLabel = this.querySelector('[data-uv-float-bg-label]');
        this.goalIcon = this.querySelector('[data-uv-goal-icon]');
        this.successIcon = this.querySelector('[data-uv-success-icon]');
        this.floatGoalIcon = this.querySelector('[data-uv-float-goal-icon]');
        this.floatSuccessIcon = this.querySelector('[data-uv-float-success-icon]');
        this.floatProgressMessage = this.querySelector('[data-uv-float-progress]');
        this.floatSuccessMessage = this.querySelector('[data-uv-float-success]');
        this.floatUi = this.querySelector('[data-uv-float]');

        this.onStandardCartUpdate = this.onStandardCartUpdate.bind(this);
        this.onLegacyCartUpdate = this.onLegacyCartUpdate.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.scheduleFit = this.scheduleFit.bind(this);

        document.addEventListener('shopify:cart:lines-update', this.onStandardCartUpdate);
        document.addEventListener('shopify:cart:discount-update', this.onStandardCartUpdate);

        this.legacyCartEvents = ['cart:updated', 'cart:changed', 'cart:refresh', 'cart:update'];
        this.legacyCartEvents.forEach((name) => {
          document.addEventListener(name, this.onLegacyCartUpdate);
        });

        window.addEventListener('pageshow', this.onPageShow);

        if ('ResizeObserver' in window && this.main) {
          this.resizeObserver = new ResizeObserver(this.scheduleFit);
          this.resizeObserver.observe(this.main);
        } else {
          window.addEventListener('resize', this.scheduleFit, { passive: true });
        }

        if (document.fonts?.ready) {
          document.fonts.ready.then(this.scheduleFit).catch(() => {});
        }

        if (this.enableFloat && this.floatUi) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.updateFloatVisibility();
        }

        this.handleSuccessAutoHide(this.dataset.state === 'success', false);
        this.scheduleFit();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.onStandardCartUpdate);
        document.removeEventListener('shopify:cart:discount-update', this.onStandardCartUpdate);

        this.legacyCartEvents?.forEach((name) => {
          document.removeEventListener(name, this.onLegacyCartUpdate);
        });

        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.scheduleFit);

        this.resizeObserver?.disconnect();

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.fitFrame) cancelAnimationFrame(this.fitFrame);
        if (this.legacyRefreshTimer) clearTimeout(this.legacyRefreshTimer);
        if (this.successHideTimer) clearTimeout(this.successHideTimer);
        this.legacyAbortController?.abort();
      }

      scheduleFit() {
        if (!this.main || this.fitFrame) return;

        this.fitFrame = requestAnimationFrame(() => {
          this.fitFrame = 0;
          this.fitOneLine();
        });
      }

      fitOneLine() {
        if (!this.main || this.main.clientWidth <= 0) return;

        const main = this.main;
        const track = this.trackShell;

        main.dataset.uvTight = 'false';
        main.style.fontSize = `${this.configuredFontSize}px`;

        if (track) {
          track.style.removeProperty('width');
          track.style.removeProperty('flex-basis');
          track.style.removeProperty('min-width');
        }

        const fits = () => main.scrollWidth <= main.clientWidth + 1;
        if (fits()) return;

        let low = this.minimumFitFontSize;
        let high = this.configuredFontSize;
        let best = this.minimumFitFontSize;

        for (let i = 0; i < 7; i += 1) {
          const mid = (low + high) / 2;
          main.style.fontSize = `${mid}px`;

          if (fits()) {
            best = mid;
            low = mid;
          } else {
            high = mid;
          }
        }

        main.style.fontSize = `${Math.max(this.minimumFitFontSize, best).toFixed(2)}px`;
        if (fits()) return;

        main.dataset.uvTight = 'true';

        if (track) {
          const overflow = Math.max(0, main.scrollWidth - main.clientWidth);
          const currentWidth = track.getBoundingClientRect().width;
          const targetWidth = Math.max(44, currentWidth - overflow - 2);
          track.style.width = `${targetWidth}px`;
          track.style.flexBasis = `${targetWidth}px`;
          track.style.minWidth = '44px';
        }

        if (fits()) return;

        const overflowRatio = Math.min(1, main.clientWidth / Math.max(main.scrollWidth, 1));
        const finalSize = Math.max(8, this.minimumFitFontSize * overflowRatio);
        main.style.fontSize = `${finalSize.toFixed(2)}px`;
      }

      async onStandardCartUpdate(event) {
        if (!event.promise || typeof event.promise.then !== 'function') return;

        try {
          const result = await event.promise;
          const cart = result?.cart;
          if (!cart) return;

          this.lastNativeCartUpdate = performance.now();
          this.updateFromCart(cart);
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.warn('[UV Shipping Goal] Native cart update could not be read.', error);
          }
        }
      }

      onLegacyCartUpdate(event) {
        const candidate = event?.detail?.cart || event?.detail;
        if (candidate && this.updateFromCart(candidate)) return;

        if (performance.now() - (this.lastNativeCartUpdate || 0) < 500) return;

        this.scheduleLegacyRefresh();
      }

      updateFromCart(cart) {
        if (!cart || typeof cart !== 'object') return false;

        if ('totalQuantity' in cart || cart.cost?.totalAmount) {
          const itemCount = Number(cart.totalQuantity) || 0;
          const total = Number(cart.cost?.totalAmount?.amount) || 0;
          const currency = cart.cost?.totalAmount?.currencyCode || this.currencyCode;
          this.update(itemCount, total, currency);
          return true;
        }

        if ('item_count' in cart || 'total_price' in cart) {
          const itemCount = Number(cart.item_count) || 0;
          const total = (Number(cart.total_price) || 0) / 100;
          const currency = cart.currency || this.currencyCode;
          this.update(itemCount, total, currency);
          return true;
        }

        return false;
      }

      scheduleLegacyRefresh() {
        if (this.legacyRefreshTimer) clearTimeout(this.legacyRefreshTimer);

        this.legacyRefreshTimer = setTimeout(() => {
          this.legacyRefreshTimer = 0;
          this.refreshCart();
        }, 90);
      }

      async refreshCart() {
        this.legacyAbortController?.abort();
        this.legacyAbortController = new AbortController();

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: this.legacyAbortController.signal,
          });

          if (!response.ok) return;
          const cart = await response.json();
          this.updateFromCart(cart);
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.warn('[UV Shipping Goal] Legacy cart refresh failed.', error);
          }
        }
      }

      onPageShow(event) {
        if (event.persisted) this.refreshCart();
      }

      onScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.updateFloatVisibility();
        });
      }

      updateFloatVisibility() {
        if (!this.floatUi) return;
        const shouldShow = window.scrollY > 100 && this.currentItemCount > 0;
        this.floatUi.classList.toggle('is-visible', shouldShow);
        this.floatUi.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      handleSuccessAutoHide(success, wasSuccess) {
        if (this.successHideTimer) {
          clearTimeout(this.successHideTimer);
          this.successHideTimer = 0;
        }

        if (!this.autoHideOnSuccess) {
          this.hidden = false;
          return;
        }

        if (!success) {
          this.hidden = false;
          return;
        }

        /* If it was already hidden and the cart is still above the goal, keep it hidden. */
        if (wasSuccess && this.hidden) return;

        this.hidden = false;
        this.successHideTimer = setTimeout(() => {
          this.successHideTimer = 0;
          if (this.dataset.state === 'success') this.hidden = true;
        }, this.successHideDelay);
      }

      formatRemaining(value) {
        if (this.thresholdMode === 'items') {
          const count = Math.max(0, Math.ceil(value));
          return `${count} ${count === 1 ? this.itemLabelSingular : this.itemLabelPlural}`;
        }

        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: this.currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Math.max(0, value));
        } catch (_) {
          return `${Math.max(0, value).toFixed(2)}`;
        }
      }

      update(itemCount, cartTotal, currencyCode) {
        this.currentItemCount = Math.max(0, Number(itemCount) || 0);
        this.currentCartTotal = Math.max(0, Number(cartTotal) || 0);
        if (currencyCode) this.currencyCode = currencyCode;

        const threshold = this.thresholdMode === 'items' ? this.thresholdItems : this.thresholdAmount;
        const current = this.thresholdMode === 'items' ? this.currentItemCount : this.currentCartTotal;
        const remaining = Math.max(0, threshold - current);
        const empty = this.currentItemCount === 0;
        const success = !empty && current >= threshold;
        const wasSuccess = this.dataset.state === 'success';
        const state = empty ? 'empty' : success ? 'success' : 'progress';
        const progress = threshold > 0 ? Math.min(1, Math.max(0, current / threshold)) : 1;

        this.dataset.state = state;

        Object.entries(this.stateNodes).forEach(([name, node]) => {
          if (node) node.hidden = name !== state;
        });

        const remainingText = this.formatRemaining(remaining);
        this.remainingNodes.forEach((node) => {
          node.textContent = remainingText;
        });

        if (this.progressWrap) this.progressWrap.hidden = empty;
        if (this.floatProgressWrap) this.floatProgressWrap.hidden = empty;

        const hideTrackOnSuccess = success && this.hideProgressOnSuccess;
        if (this.trackShell) this.trackShell.hidden = hideTrackOnSuccess;
        if (this.floatTrackShell) this.floatTrackShell.hidden = hideTrackOnSuccess;

        this.fills.forEach((fill) => {
          fill.style.transform = `scaleX(${progress})`;
        });

        if (this.movingIcon) {
          this.movingIcon.style.left = `${progress * 100}%`;
          this.movingIcon.hidden = success;
        }

        if (this.bgLabel) this.bgLabel.hidden = success;
        if (this.floatBgLabel) this.floatBgLabel.hidden = success;

        if (this.goalIcon) this.goalIcon.hidden = success;
        if (this.successIcon) this.successIcon.hidden = !success;
        if (this.floatGoalIcon) this.floatGoalIcon.hidden = success;
        if (this.floatSuccessIcon) this.floatSuccessIcon.hidden = !success;
        if (this.floatProgressMessage) this.floatProgressMessage.hidden = success;
        if (this.floatSuccessMessage) this.floatSuccessMessage.hidden = !success;

        if (this.progressBar) {
          this.progressBar.setAttribute('aria-valuemax', String(threshold));
          this.progressBar.setAttribute('aria-valuenow', String(Math.min(current, threshold)));
          this.progressBar.setAttribute(
            'aria-valuetext',
            success ? 'Free shipping unlocked' : `${remainingText} remaining for free shipping`
          );
        }

        this.handleSuccessAutoHide(success, wasSuccess);
        this.updateFloatVisibility();
        this.scheduleFit();
      }
    }

    customElements.define('uv-shipping-goal', UVShippingGoal);
  })();

  } catch(e) { console.error(e); }
})();
})();
